import React from 'react';

const VISIBILITY_LABELS = {
  ORDERING_PARTNERS: 'Partners',
  TOAST_ONLINE_ORDERING: 'Online',
  POS: 'POS',
  KIOSK: 'Kiosk'
};

export default function VisibilityBadges({ visibility }) {
  let channels = [];
  try {
    channels = JSON.parse(visibility || '[]');
  } catch (e) {
    channels = [];
  }

  if (!Array.isArray(channels) || channels.length === 0) {
    return <span className="visibility-empty">-</span>;
  }

  return (
    <div className="visibility-badges">
      {channels.map(channel => (
        <span key={channel} className="visibility-badge" title={channel}>
          {VISIBILITY_LABELS[channel] || channel}
        </span>
      ))}
    </div>
  );
}
